module.exports = __webpack_public_path__ + "static/media/nextJS.9037feaf.svg";